import { render, staticRenderFns } from "./Compose.vue?vue&type=template&id=6c70d38b&scoped=true&"
import script from "./Compose.vue?vue&type=script&lang=js&"
export * from "./Compose.vue?vue&type=script&lang=js&"
import style0 from "./Compose.vue?vue&type=style&index=0&id=6c70d38b&scoped=true&lang=css&"
import style1 from "./Compose.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c70d38b",
  null
  
)

export default component.exports